export const fileToString = async (file: File) => {
    const content = await new Promise<string>((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
            resolve(reader.result as string)
        }
        reader.onerror = () => {
            reject(reader.error)
        }
        reader.readAsText(file)
    })
    return content
}
